"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityQuoteEntry = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const look_up_entity_1 = require("./look-up.entity"); // Assuming you have this
const insurer_entity_1 = require("./insurer.entity"); // Assuming you have this
const opportunity_broking_slip_version_entity_1 = require("./opportunity-broking-slip-version.entity");
const opportunity_quote_entry_document_map_entity_1 = require("./opportunity-quote-entry-document-map.entity");
const opportunity_quote_entry_cover_detail_entity_1 = require("./opportunity-quote-entry-cover-detail.entity");
const opportunity_quote_entry_tax_map_entity_1 = require("./opportunity-quote-entry-tax-map.entity");
let OpportunityQuoteEntry = class OpportunityQuoteEntry {
};
exports.OpportunityQuoteEntry = OpportunityQuoteEntry;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "broking_slip_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "brokingSlipId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quote_received_on", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityQuoteEntry.prototype, "quoteReceivedOn", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "basic_premium", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "basicPremium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "terrorism_cover", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "terrorismCover", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "net_premium", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "netPremium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "brokerage_percent", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "brokeragePercent", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteEntry.prototype, "insurerRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "attachment_url", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityQuoteEntry.prototype, "attachmentUrl", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "statusId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteEntry.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityQuoteEntry.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityQuoteEntry.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OpportunityQuoteEntry.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_quote_entry_document_map_entity_1.OpportunityQuoteEntryDocumentMap, (docMap) => docMap.quoteEntry),
    tslib_1.__metadata("design:type", Array)
], OpportunityQuoteEntry.prototype, "documentMappings", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "SET NULL",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], OpportunityQuoteEntry.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: "status_id" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], OpportunityQuoteEntry.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_entity_1.Insurer, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: "insurer_id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], OpportunityQuoteEntry.prototype, "insurer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_broking_slip_version_entity_1.BrokingSlipVersionDetails, (brokingSlipVersion) => brokingSlipVersion.quoteEntry, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: "broking_slip_id" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof opportunity_broking_slip_version_entity_1.BrokingSlipVersionDetails !== "undefined" && opportunity_broking_slip_version_entity_1.BrokingSlipVersionDetails) === "function" ? _h : Object)
], OpportunityQuoteEntry.prototype, "brokingSlipVersion", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_quote_entry_cover_detail_entity_1.OpportunityQuoteCoverDetail, (coverDetail) => coverDetail.quote, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityQuoteEntry.prototype, "coverDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_quote_entry_tax_map_entity_1.OpportunityQuoteTaxMap, (tax) => tax.quoteEntry, {
        onDelete: "CASCADE",
    }),
    tslib_1.__metadata("design:type", Array)
], OpportunityQuoteEntry.prototype, "taxMappings", void 0);
exports.OpportunityQuoteEntry = OpportunityQuoteEntry = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_quote_entry")
], OpportunityQuoteEntry);
